import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import is from "./filter-set.js";
var ls = /*#__PURE__*/function () {
  function ls(t, s) {
    _classCallCheck(this, ls);
    this.wc = t, this.tf = s, this.wc = t, this.tf = s;
  }
  _createClass(ls, [{
    key: "xc",
    value: function xc(t) {
      if (null == this.wc || null == this.tf) return !1;
      var s = t[0],
        i = t[1];
      return s === this.wc && this.tf.xc(i);
    }
  }, {
    key: "dt",
    value: function dt() {
      return {
        e: this.wc,
        pf: this.tf ? this.tf.dt() : null
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ls(t ? t.event_name : null, t ? is.fromJson(t.property_filters) : null);
    }
  }]);
  return ls;
}();
export { ls as default };